import {
  getCurrentBrand,
  type Brand,
  isTestStage,
} from '@/shared/config/brand-by-target.mjs';

type RuntimeEnv = 'stage' | 'prod';

const SERVER_API_BASE_URL_MAP: Record<RuntimeEnv, Partial<Record<Brand, string>>> = {
  stage: {
    pw: 'https://pw.stage.pingwin.fun/server',
    lm: 'https://lm.stage.pingwin.fun/server',
    ph: 'https://ph.stage.pingwin.fun/server',
    ph2: 'https://ph2.stage.pingwin.fun/server',
  },
  prod: {
    pw: 'https://pingwincasino3.com/server',
    lm: 'https://loto-million.net/server',
    ph: 'https://inplay.powerplay.ph/server',
    ph2: 'https://pingwin.ph/server',
  },
};

function normalizeBaseUrl(url: string) {
  return url.replace(/\/$/, '');
}

function getRuntimeEnv(): RuntimeEnv {
  return isTestStage ? 'stage' : 'prod';
}

export function getServerApiBaseUrl(): string {
  const override = process.env.SERVER_API_BASE_URL;
  if (override) {
    return normalizeBaseUrl(override);
  }

  const brand = getCurrentBrand();
  const runtimeEnv = getRuntimeEnv();
  const mappedUrl = SERVER_API_BASE_URL_MAP[runtimeEnv]?.[brand];

  if (!mappedUrl) {
    throw new Error(
      `Missing server API base URL for brand=${brand}, env=${runtimeEnv}`
    );
  }

  return normalizeBaseUrl(mappedUrl);
}
